/*
    Allow elements to collapse at small viewports while remaining open at large viewports
*/

EventBus.subscribe('init-modules', function () {
    
    var elements = jQuery('.collapse-responsive');

    //Return if no collapsable elements found
    if (elements.length === 0) {
        return;
    }
    
    //Function for gettings element's toggler
    var getToggle = function (element) {
        return jQuery(element.data('toggled-by'));
    };

    //Setup resize functions
    
    var handleResize = function () {
        
        var
            element,
            toggle
        ;

        elements.each(function () {
            
            element = jQuery(this);
            toggle = getToggle(element);
            
            if (window.matchMedia('(max-width: ' + parseInt(element.data('collapse-width')) + 'px)').matches) {
                if (!element.hasClass('opened')) {
                    element.stop().hide();
                }
            }
            else {
                element.stop().show();
            }
            
        });
        
    };

    jQuery(window).resize(handleResize);
    handleResize();
    
    //Setup toggle click listener
    jQuery(document).on('click', '.collapse-responsive-toggle', function (e) {
        
        e.preventDefault();
        
        var
            clicked = jQuery(this),
            target = clicked.attr('href'),
            element = jQuery(target),
            toggle = getToggle(element)
        ;
        
        element.stop().slideToggle().toggleClass('opened');
        element.hasClass('opened') ? toggle.addClass('opened') : toggle.removeClass('opened');
        
    });
    
})